/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowLoopLeft = createReactComponent("outline", "arrow-loop-left", "IconArrowLoopLeft", [["path", { "d": "M13 21v-13a4 4 0 1 1 4 4h-13", "key": "svg-0" }], ["path", { "d": "M8 16l-4 -4l4 -4", "key": "svg-1" }]]);

export { IconArrowLoopLeft as default };
//# sourceMappingURL=IconArrowLoopLeft.mjs.map
